import {FC} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '../../../../config/store';
import {RevenueSelector} from './ui';
import {
    rKeeperSelect,
    setSelectedRestaurant,
} from '../../../../entities/rKeeper';
import {flexMixin, textMixin} from '../../../../styles/mixins';
import {colors} from '../../../../styles';
import {formatNumberWithDot} from '../../../../utils/functions/formatNumberWithDot';

const HeaderRestaurantsInfo: FC = () => {
    const {selectedRestaurant, restaurants, restTotal} =
        useSelector(rKeeperSelect);
    const dispatch = useDispatch<AppDispatch>();

    return (
        <HeaderInfoWrap>
            <CardInfo>
                <CardSelectBox>
                    <RevenueSelector
                        options={restaurants}
                        setSelectValue={(val) =>
                            dispatch(setSelectedRestaurant(val))
                        }
                        value={selectedRestaurant}
                    />
                    <CardTextSelect>рестораны</CardTextSelect>
                </CardSelectBox>
            </CardInfo>
            <CardInfo>
                <CardTextArea>
                    <CardTitle>
                        {restTotal?.sum
                            ? formatNumberWithDot(restTotal?.sum)
                            : '0 р.'}
                    </CardTitle>
                    <CardText>выручка за период</CardText>
                </CardTextArea>
            </CardInfo>
            <CardInfo>
                <CardTextArea>
                    <CardTitle>{`${restTotal?.checks || 0} шт`}</CardTitle>
                    <CardText>кол-во чеков</CardText>
                </CardTextArea>
            </CardInfo>
            <CardInfo>
                <CardTextArea>
                    <CardTitle>
                        {restTotal?.average
                            ? formatNumberWithDot(restTotal?.average)
                            : '0 р.'}
                    </CardTitle>
                    <CardText>средний чек</CardText>
                </CardTextArea>
            </CardInfo>
        </HeaderInfoWrap>
    );
};

export default HeaderRestaurantsInfo;

const HeaderInfoWrap = styled.div`
    ${flexMixin('row', 'space-between', 'center')};
    flex-wrap: wrap;
    gap: 20px;
`;

const CardInfo = styled.div`
    ${flexMixin('row', 'space-between', 'center')};
    min-width: 200px;
    flex: 1;
`;

const CardTextArea = styled.div`
    width: 100%;
    height: 92px;
    background: ${colors.cleanWhite};
    box-shadow: 0px 2px 15.2px rgba(0, 0, 0, 0.11);
    border-radius: 5px;
    ${flexMixin('column', 'center', 'flex-start')};
    padding-left: 16px;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

const CardTitle = styled.div`
    ${textMixin({
        fontSize: '30px',
        fontWeight: 600,
    })};
    line-height: 34px;
    align-items: center;
    color: ${colors.grey};
    @media (max-width: 1500px) {
        font-size: 24px;
    }
`;

const CardText = styled.div`
    height: 28px;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 28px;
    align-items: center;
    color: #8f8f8f;
`;

const CardSelectBox = styled(CardTextArea)`
    padding-left: 0px;
`;
const CardTextSelect = styled(CardText)`
    padding-left: 16px;
`;
